var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThumbsUpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2111 21.2238C12.2075 21.2329 12.2 21.2567 12.2 21.3V34.9C12.2 34.9433 12.2075 34.9671 12.2111 34.9762C12.2131 34.981 12.2146 34.9836 12.2153 34.9847C12.2164 34.9854 12.219 34.9869 12.2238 34.9889C12.2329 34.9925 12.2567 35 12.3 35H17V21.2H12.3C12.2567 21.2 12.2329 21.2075 12.2238 21.2111C12.219 21.2131 12.2164 21.2146 12.2153 21.2153C12.2146 21.2164 12.2131 21.219 12.2111 21.2238ZM10 21.3C10 19.9925 10.9925 19 12.3 19H19.2V37.2H12.3C10.9925 37.2 10 36.2075 10 34.9V21.3Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7296 11.1816C22.1459 10.3756 22.9525 10 23.7 10H24.3C27.415 10 29.6475 12.8756 28.8644 15.8777L28.8629 15.8834L28.0318 19H33.5C36.3615 19 38.6214 21.6043 37.9793 24.5142L36.2838 34.288L36.2833 34.2912C35.8946 36.4936 33.957 38.2 31.7 38.2H21.2C21.1013 38.2 21.0185 38.1882 20.9639 38.1784C20.9067 38.1681 20.857 38.1557 20.82 38.1456C20.7627 38.13 20.7065 38.1117 20.6715 38.1H20.6276L16.9 36.9019V19.8132L21.7296 11.1816ZM23.6786 12.2024L23.6725 12.2148L19.1 20.3868V35.2981L21.0443 35.9231C21.098 35.933 21.1448 35.9448 21.1801 35.9544C21.2373 35.97 21.2935 35.9883 21.3285 36H31.7C32.8425 36 33.9044 35.1072 34.1165 33.9106C34.1166 33.91 34.1167 33.9094 34.1168 33.9088L35.8211 24.084L35.8274 24.0562C36.1633 22.5781 35.0289 21.2 33.5 21.2H25.1683L26.7363 15.3197C27.1512 13.7227 25.9841 12.2 24.3 12.2H23.7C23.6916 12.2 23.6843 12.201 23.6786 12.2024Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 28.2,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsUpLight);
export default __webpack_public_path__ + "static/media/icon_thumbs_up_light.66c5e87d.svg";
export { ForwardRef as ReactComponent };